import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3, FiRefreshCcw, FiSliders, FiFile } from "react-icons/fi";
import { FiEye } from "react-icons/fi";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import {
  fetchData,
  getValueLabel,
  fetchFormData,
  formatDateOnly,
} from "../../utils/options";
import FollowUpModal from "../../utils/FollowUpModal";
import InquiryStageModal from "../../utils/InquiryStageModal";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import Swal from "sweetalert2";
import topTost from "../../utils/topTost";
import { leadPriorityData } from "../../utils/options";
import DocumentModal from "../../utils/DocumentModal";

const Loan_InquiryTable = ({ filteredData = null, permission }) => {
  const [branchData, setBranchData] = useState([]);
  const [showFollowUpModal, setShowFollowUpModal] = useState(false);
  const [followUpDate, setFollowUpDate] = useState(null);
  const [selectedInquiryId, setSelectedInquiryId] = useState(null);
  const [showInquiryStageModal, setShowInquiryStageModal] = useState(false);
  const [documentModal, setDocumentModal] = useState(false);
  const [inquiryStageData, setInquiryStageData] = useState([]);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [isSettled, setIsSettled] = useState(false);
  const [transactionDetails, setTransactionDetails] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedInquiryStage, setSelectedInquiryStage] = useState("");
  const [documentsImage, setDocumentsImage] = useState(null);
  const [documents, setDocuments] = useState([
    { id: "0", name: "", images: [] },
  ]);

  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const LeadTypeId = queryParams.get("leadTypeId");
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const { fromDate, toDate } = location.state || {};

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const handleConfirm = async () => {
    const formData = new FormData();
    formData.append("loan_inquiry_id", selectedInquiryId);
    formData.append("follow_up_date", followUpDate);
    formData.append("created_by", userId);

    try {
      const response = await fetchFormData("loan-follow-up", formData, "POST");

      if (response?.code === 201) {
        topTost({
          title: "Follow-up added successfully",
          icon: "success",
        });
        setShowFollowUpModal(false);
        setSelectedInquiryId(null);
        fetchInitialData();
      }
    } catch (error) {
      console.error("Error submitting follow-up date:", error);
    }
  };

  const fetchInitialData = async () => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);
    formData.append("statusId", LeadTypeId || "");
    formData.append("fromDate", fromDate || "");
    formData.append("toDate", toDate || "");
    try {
      Swal.fire({
        title: "Loading ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const [branchResult, stageResult] = await Promise.all([
        fetchFormData("list-loan-inquiries", formData, "POST"),
        fetchData("loan-inquiry-statusesDrop", formData, "POST"),
      ]);

      if (branchResult) {
        setBranchData(branchResult.users || []);
      }

      if (stageResult) {
        setInquiryStageData(
          getValueLabel(stageResult.states, "loan_inquiry_status", "id") || []
        );
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
      Swal.fire("Error", "Failed to load data", "error");
    } finally {
      Swal.close();
    }
  };

  useEffect(() => {
    if (LeadTypeId) {
      fetchInitialData();
    }
  }, [LeadTypeId]);

  const selectedInquiry = branchData.find(
    (item) => item.id === selectedInquiryId
  );

  const selectedAmount = selectedInquiry?.loan_amount ?? 0;

  const columns = [
    ...(permission?.pf_edit === 1 || permission?.pf_edit === 1
      ? [
          {
            accessorKey: "actions",
            header: () => "Actions",
            cell: ({ row }) => {
              const id = row.original.id;
              return (
                <div className="hstack gap-2 justify-content-end">
                  {permission?.pf_edit === 1 && (
                    <span
                      className="cursor-pointer"
                      onClick={() => navigate(`/inquiry/history/${id}`)}
                      title="Inquiry History"
                    >
                      <FiEye size={16} />
                    </span>
                  )}
                  {permission?.pf_edit === 1 && (
                    <span
                      className="cursor-pointer"
                      onClick={() =>
                        navigate(`/inquiry/edit-inquiry/${id}?id=${M_id}`)
                      }
                      title="Edit Inquiry"
                    >
                      <FiEdit3 size={16} />
                    </span>
                  )}
                  {permission?.pf_edit === 1 && (
                    <span
                      className="cursor-pointer"
                      onClick={() => {
                        setSelectedInquiryId(id);
                        setShowFollowUpModal(true);
                      }}
                      title="Follow Up"
                    >
                      <FiRefreshCcw size={16} />
                    </span>
                  )}
                  {permission?.pf_edit === 1 &&
                    Number(row.original.loan_amount) > 0 && (
                      <span
                        className="cursor-pointer"
                        onClick={() => {
                          setSelectedInquiryId(id);
                          setSelectedInquiryStage(
                            row.original?.loan_inquiry_status_id || ""
                          );
                          setShowInquiryStageModal(true);
                        }}
                        title="Inquiry Stage"
                      >
                        <FiSliders size={16} />
                      </span>
                    )}
                  {permission?.pf_edit === 1 && (
                    <span
                      className="cursor-pointer"
                      onClick={() => {
                        setSelectedInquiryId(id);
                        setShowDocumentModal(true);
                      }}
                      title="Document"
                    >
                      <FiFile size={16} />
                    </span>
                  )}
                   {/* {permission?.pf_edit === 1 && (
                    <span
                      className="cursor-pointer"
                      onClick={() => {
                        setSelectedInquiryId(id);
                        setShowDocumentModal(true);
                      }}
                      title="Document"
                    >
                      <FiShare size={16} />
                    </span>
                  )} */}
                </div>
              );
            },
            meta: {
              headerClassName: "width-30",
              exportable: false,
            },
          },
        ]
      : []),
    {
      accessorKey: "lead_priority",
      header: "Inquiry Priority",
      cell: (info) => {
        const rawVal = String(info.getValue());
        const priority = leadPriorityData.find((item) => item.value === rawVal);
        if (!priority) {
          return (
            <span className="badge bg-soft-secondary text-secondary"></span>
          );
        }
        const colorMap = {
          "#E53935": "danger", // Red - Very High
          "#FB8C00": "warning", // Orange - High
          "#43A047": "success", // Green - Medium
          "#1E88E5": "primary", // Blue - Low
          "#8E24AA": "purple", // Purple - Info-like
          "#FDD835": "yellow", // Yellow - Moderate
          "#6D4C41": "brown", // Brown - Special
          "#00ACC1": "cyan", // Cyan - Info
          "#F06292": "pink", // Pink - Misc
          "#757575": "secondary",
        };

        const bootstrapColor = colorMap[priority.color] || "secondary";

        return (
          <span
            className={`badge bg-soft-${bootstrapColor} text-${bootstrapColor}`}
          >
            {priority.label}
          </span>
        );
      },
      defaultIsVisible: true,
    },
    {
      accessorKey: "loan_inquiry_status",
      header: "Inquiry Status",
      defaultIsVisible: true,
      cell: (info) => {
        const status = info.getValue();
        return (
          <span
            style={{
              backgroundColor: "#e3f2fd",
              color: "#0d6efd",
              padding: "4px 8px",
              borderRadius: "0.25rem",
              fontSize: "11px",
              display: "inline-block",
            }}
          >
            {status}
          </span>
        );
      },
    },
    {
      accessorKey: "customer_name",
      header: "Customer Name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "phone_number",
      header: "Phone Number",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "loan_type_name",
      header: "Type",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "loan_amount",
      header: "Inquiry Amount",
      defaultIsVisible: true,
      cell: (info) =>
        Number(info.getValue()).toLocaleString("en-IN", {
          style: "currency",
          currency: "INR",
        }),
    },
    {
      accessorKey: "lead_source_name",
      header: "Inquiry Source",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "inquiry_date",
      header: "Inquiry Date",
      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },
    {
      accessorKey: "Inquiries_Id",
      header: "Inquiries id",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "alternate_number",
      header: "Alternate Number",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "address",
      header: "Address",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "state_name",
      header: "State",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "district_name",
      header: "district",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "city_name",
      header: "City",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "refrence_name",
      header: "Reference Name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "refrence_mobile",
      header: "Reference Mobile",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "follow_up_date",
      header: "Follow-up Date",
      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },

    {
      accessorKey: "remarks",
      header: "Remarks",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "assigned_user",
      header: "Assigned To",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "is_converted",
      header: "Converted",
      cell: (info) => (info.getValue() === 1 ? "Yes" : "No"),
    },
    {
      accessorKey: "converted_date",
      header: "Converted Date",
      cell: (info) =>
        info.getValue()
          ? new Date(info.getValue()).toLocaleDateString("en-GB")
          : "—",
    },
    {
      accessorKey: "created_user",
      header: "Created By",
      cell: (info) => info.getValue(), // map if needed
    },
  ];

  useEffect(() => {
    const shouldFetch =
      !Array.isArray(filteredData) || filteredData.length === 0;

    if (shouldFetch) {
      fetchInitialData();
    } else {
      setBranchData(filteredData);
    }
  }, [filteredData]);

  return (
    <>
      <Table data={branchData} columns={columns} />
      <FollowUpModal
        show={showFollowUpModal}
        onClose={() => setShowFollowUpModal(false)}
        onConfirm={handleConfirm}
        followUpDate={followUpDate}
        setFollowUpDate={setFollowUpDate}
      />
      <InquiryStageModal
        show={showInquiryStageModal}
        onClose={() => setShowInquiryStageModal(false)}
        inquiryStageData={inquiryStageData}
        selectedInquiryId={selectedInquiryId}
        selectedInquiryStage={selectedInquiryStage}
        onConfirm={() => {
          setShowInquiryStageModal(false);
          window.location.reload();
        }}
        amount={selectedAmount}
      />

      <DocumentModal
        show={showDocumentModal}
        onClose={() => setShowDocumentModal(false)}
        selectedInquiryId={selectedInquiryId}
        documents={documents}
        setDocuments={setDocuments}
      />
    </>
  );
};

export default Loan_InquiryTable;
